import type { TimersShow } from '@/types';
import { TimerView } from './components/timer-view';

// `/:eventSlug/timer` (app/(public)/[locale]/timer/page.tsx) — the clock projected next
// to the stage. The controller resolves which stage it follows; everything after that is
// the two-second poll inside TimerView.
export default function Show({ eventSlug, stageSlug }: TimersShow) {
  return <TimerView eventSlug={eventSlug} stageSlug={stageSlug} />;
}
